import { motion } from "framer-motion";
import { ShowroomPinHost, shopName, useShowroom } from "./showroom";
import "./shopBrand.css";

// The nav bar's mark for a verified boutique (agreed 2026-10-29). With costs
// showing (My cost) it is the plain MAVIINCI logo. In showroom, the shop's
// name takes the centre with "with MAVIINCI" under it, so the client sees
// the boutique's own collection. Switching mode cross-fades once; nothing
// loops. Anyone else sees the plain logo.
// `motionStyle` carries the home page's scroll scale onto the whole mark.

export default function ShopBrand({ children, motionStyle, small = false }) {
    const { isBiz, showroom, biz } = useShowroom();
    const name = isBiz ? shopName(biz) : "";
    const Wrap = motionStyle ? motion.span : "span";
    return (
        <>
            {isBiz && <ShowroomPinHost />}
            <Wrap className={`mv-brand${name ? " is-biz" : ""}${showroom ? " is-show" : ""}${small ? " is-small" : ""}`} style={motionStyle || undefined}>
                <span className="mv-brand__logo" aria-hidden={showroom || undefined}>{children}</span>
                {name && (
                    <span className="mv-brand__shop" aria-hidden={!showroom || undefined}>
                        <b>{name}</b>
                        <small>with MAVIINCI</small>
                    </span>
                )}
            </Wrap>
        </>
    );
}
